import { useAuthContext } from '../contexts/AuthContext';
import { Permission, UserDto, UserRole } from '../types/user';
import { resolveUserPermissions } from '../lib/permissions';

export {
  resolveUserPermissions,
  permissionLabel,
  setPermissionLabelCatalog,
} from '../lib/permissions';

export const useAuth = () => {
  const { isAuthenticated, token, logout } = useAuthContext();
  return { isAuthenticated, token, logout };
};

export const useCurrentUser = (): UserDto | null => {
  const { user } = useAuthContext();
  return user;
};

export const useHasPermission = (permission: Permission): boolean => {
  const { user } = useAuthContext();
  return resolveUserPermissions(user).includes(permission);
};

export const useHasRole = (minimumRole: UserRole): boolean => {
  const { user } = useAuthContext();
  return user ? user.role >= minimumRole : false;
};
